import { combineReducers } from 'redux';

import { reducer as actorsReducer } from '@savgroup-front-common/core/domains/actors';
import { reducer as attachmentsReducer } from '@savgroup-front-common/core/domains/attachments';
import { reducer as carriersReducer } from '@savgroup-front-common/core/domains/carriers';
import { reducer as claimsReducer } from '@savgroup-front-common/core/domains/claims';
import { reducer as fileUploadReducer } from '@savgroup-front-common/core/domains/fileUpload';
import { reducer as i18nReducer } from '@savgroup-front-common/core/domains/i18n';
import routerReducer from '@savgroup-front-common/core/domains/router/reducer';
import { reducer as sagaRequestMetadataReducer } from '@savgroup-front-common/core/domains/sagaRequestMetadata';
import { reducer as sellerConfigurationReducer } from '@savgroup-front-common/core/domains/sellerConfiguration';
import { sellerReducer } from '@savgroup-front-common/core/domains/sellers';
import { storeReducer } from '@savgroup-front-common/core/domains/store';
import { technicalInterventionsReducer } from '@savgroup-front-common/core/domains/technicalInterventions';
import { reducer as workflowReducer } from '@savgroup-front-common/core/domains/workflow';

import { reducer as claimReducer } from './Claim';
import { reducer as customerReducer } from './Customer';
import myOrderFeatureReducer from './Orders/reducer';
import { reducer as ownerReducer } from './owner';
import profileManagementReducer from './ProfileManagement/reducer';

const rootReducer = () =>
  combineReducers({
    actors: actorsReducer,
    attachments: attachmentsReducer,
    carriers: carriersReducer,
    claim: claimReducer,
    claims: claimsReducer,
    customer: customerReducer,
    fileUpload: fileUploadReducer,
    i18n: i18nReducer,
    orders: myOrderFeatureReducer,
    owner: ownerReducer,
    profileManagement: profileManagementReducer,
    router: routerReducer,
    store: storeReducer,
    sellers: sellerReducer,
    sagaRequestMetadata: sagaRequestMetadataReducer,
    sellerConfiguration: sellerConfigurationReducer,
    technicalInterventions: technicalInterventionsReducer,
    workflow: workflowReducer,
  });

export default rootReducer;
